import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { Typography, Box, MenuItem } from '@mui/material';
import { FC, MouseEvent, useState } from 'react';

import ManagementSubheader from 'components/ManagementSubheader';
import DiscountModal from 'containers/PosOrderDetailsPage/DiscountModal';
import {
  Content, Status, InfoWrapper, StatusWraper, ActionButton, EditMenu,
} from 'containers/PosOrderDetailsPage/Title/index.styled';
import { getEditOptions } from 'containers/PosOrderDetailsPage/Title/utils';

import { capitalizeOneString } from 'utils/text';

interface TitleProps {
  orderId: number;
  status: string;
  useType: string;
  refreshOrder: () => void;
}

const Title:FC<TitleProps> = ({
  orderId,
  status,
  useType,
  refreshOrder,
}) => {
  const [openDiscount, setOpenDiscount] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isEditOpen = Boolean(anchorEl);
  const editOptions = getEditOptions();

  const handleCloseEdit = () => {
    setAnchorEl(null);
  };

  const handleOpenEdit = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectEditOption = () => {
    handleCloseEdit();
  };

  return (
    <ManagementSubheader
      hasBackButton
      title={`Order ${orderId}`}
    >
      <Content>
        <Box display="flex" alignItems="center" justifyContent="flex-end" width="100%" gap={2}>
          <StatusWraper>
            <Typography>
              Status
            </Typography>
            <Status>
              <Typography fontWeight={600}>
                {status}
              </Typography>
            </Status>
          </StatusWraper>
          <InfoWrapper>
            <Typography fontWeight={600}>
              {capitalizeOneString(useType)}
            </Typography>
          </InfoWrapper>
          <ActionButton
            id="button-edit"
            variant="outlined"
            icon={<EditOutlinedIcon />}
            onClick={handleOpenEdit}
          >
            Edit
          </ActionButton>
          <EditMenu
            id="button-edit"
            aria-labelledby="button-edit"
            anchorEl={anchorEl}
            open={isEditOpen}
            onClose={handleCloseEdit}
          >
            {editOptions.map((option) => (
              <MenuItem onClick={handleSelectEditOption}>
                <Box display="flex" alignItems="center" gap={1}>
                  {option.icon}
                  <Typography>
                    {option.label}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </EditMenu>
          <ActionButton
            id="button-discount"
            variant="outlined"
            icon={<LocalOfferOutlinedIcon />}
            onClick={() => setOpenDiscount(true)}
          >
            Discount
          </ActionButton>
        </Box>
      </Content>
      <DiscountModal
        open={openDiscount}
        onClose={() => setOpenDiscount(false)}
        onSuccessHandler={refreshOrder}
      />
    </ManagementSubheader>
  );
};

export default Title;
